// removed by extract-text-webpack-plugin
module.exports = {"product-popup":"product-popup","button-close-popup":"button-close-popup","product-detail-item":"product-detail-item","product-popup-left-sider":"product-popup-left-sider","product-popup-right-detail":"product-popup-right-detail","product-info":"product-info","content-detail":"content-detail","title-collapse":"title-collapse","collapse-container":"collapse-container","slick-dots":"slick-dots","slick-thumb":"slick-thumb","product-popup-wrap":"product-popup-wrap"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/product/popup-view-detail/style.scss
// module id = ./components/partials/product/popup-view-detail/style.scss
// module chunks = 0